export const oneOf = <T extends string>(value: string | undefined, allowed: readonly T[], fallback: T): T => {
  if (typeof value !== 'string') {
    return fallback
  }
  const match = allowed.find((item) => item === value)
  return match ?? fallback
}

export const isBlankString = (value: string | undefined): boolean => {
  return typeof value !== 'string' || value.trim().length === 0
}

export const isMissingId = (value: number | undefined): boolean => {
  return typeof value !== 'number' || Number.isNaN(value) || value === 0
}
